import React from "react";
import mainStyle from "../../style/Main.module.css";
import MainLayout from "../../layouts/MainLayout";
import PageInputField from "../../components/ui/input/PagesInput/PagesInput";
import PageInputStyle from "../../components/ui/input/PagesInput/PagesInput.module.css";
import Button from "../../components/ui/buttons/Button";
import { MultiSelect } from "react-multi-select-component";
import Loader from "../../components/ui/Loader/Loader";
import { useAddEmployee } from "../../hooks/useUserList";
import { useCompanySelect } from "../../hooks/useCommonHooks";

const AddUserListPage = () => {
  const companyList = useCompanySelect();
  const { formData, loading, error, handleInputChange, handleSubmit } =
    useAddEmployee();

  const companyOptions = companyList.map((company) => ({
    label: company.label,
    value: company.value,
  }));

  const selectedCompanies = formData.company_id
    ? companyList
        .filter((c) => formData.company_id.includes(c.value))
        .map((c) => ({ label: c.label, value: c.value }))
    : [];

  return (
    <MainLayout>
      <div className={mainStyle.mainPageHeader}>
        <div>
          <p className={mainStyle.mainHeading}>Add User:</p>
        </div>
        <div className={mainStyle.mainPageButtons}></div>
      </div>

      {/* {showFilter && (
      <div className={mainStyle.mainPageFilter}>
        <p>This is your filter section</p>
      </div>
    )} */}

      <div className={mainStyle.mainContentView} style={{ height: "84%" }}>
        <div className={mainStyle.mainContentViewsb}>
          <div className={mainStyle.mainContentCard}>
            <p className={mainStyle.aboutPageContent}>
              &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Welcome to our
              chat platform! Register now to join a vibrant community where
              meaningful conversations happen every day. By signing up, you'll
              gain access to real-time messaging, personalized profiles, and a
              secure space to connect with others. Creating an account is quick
              and easy — just provide your details, choose a unique username,
              and you're all set to start chatting, sharing, and making new
              connections.
            </p>
            <div className={mainStyle.mainContentForm}>
              <div className={mainStyle.mainContentFormSplit}>
                <PageInputField
                  label="First Name"
                  name="first_name"
                  placeholder="e.g., John"
                  required
                  value={formData?.first_name || ""}
                  onChange={handleInputChange}
                  error={error.first_name}
                />

                <PageInputField
                  label="Last Name(Optional)"
                  name="last_name"
                  placeholder="e.g., Doe"
                  // required
                  value={formData?.last_name || ""}
                  onChange={handleInputChange}
                  error={error.last_name}
                />
              </div>
              <p className={mainStyle.contentGuideOrd}>
                Note : You will receive your password in this email after
                completing your registration
              </p>
              <PageInputField
                label="Email"
                name="email"
                placeholder="e.g., john.doe@example.com"
                required
                value={formData?.email || ""}
                onChange={handleInputChange}
                error={error.email}
              />
              <div className={mainStyle.mainContentFormSplit}>
                <PageInputField
                  label="Phone"
                  name="phone"
                  placeholder="e.g., 876543210"
                  required
                  value={formData?.phone || ""}
                  onChange={handleInputChange}
                  error={error.phone}
                />
                {/* <div className={mainStyle.mainInputDiv}>
                  <label htmlFor="text" className={PageInputStyle.label}>
                    Address<span className={mainStyle.mantitory}>*</span>
                  </label>
                  <textarea
                    className={PageInputStyle.input}
                    name="address"
                    placeholder="e.g.,  House No, Locality, Landmark, City, PIN"
                    value={formData.address || ""}
                    onChange={handleInputChange}
                  />
                  {error.address && (
                    <span className={mainStyle.errorMsg}>{error.address}</span>
                  )}
                </div> */}
                <div className={mainStyle.mainInputDiv}>
                  <label htmlFor="text" className={PageInputStyle.label}>
                    Company<span className={mainStyle.mantitory}>*</span>
                  </label>
                  <MultiSelect
                    options={companyOptions}
                    value={selectedCompanies}
                    onChange={(selected) =>
                      handleInputChange({
                        target: {
                          name: "company_id",
                          value: selected.map((option) => option.value),
                        },
                      })
                    }
                    labelledBy="Select Companies"
                    className={mainStyle.mutiSelectDropDown}
                    overrideStrings={{
                      allItemsAreSelected: "All companies selected",
                      selectSomeItems: "Select Companies",
                    }}
                  />
                  {error.company_id && (
                    <span className={mainStyle.errorMsg}>
                      {error.company_id}
                    </span>
                  )}
                </div>
              </div>

              <div className={mainStyle.mainContentFormSplit}>
                <div className={mainStyle.mainInputDiv}>
                  <label htmlFor="text" className={PageInputStyle.label}>
                    Address<span className={mainStyle.mantitory}>*</span>
                  </label>
                  <textarea
                    className={PageInputStyle.input}
                    name="address"
                    placeholder="e.g.,  House No, Locality, Landmark, City, PIN"
                    value={formData?.address || ""}
                    onChange={handleInputChange}
                  />
                  {error.address && (
                    <span className={mainStyle.errorMsg}>{error.address}</span>
                  )}
                </div>
                {/* <SelectBox
                                    options={companyList}
                                    label="Company"
                                    name="company"
                                    value={formData.company}
                                    onChange={handleInputChange}  // Add this line
                                    placeholder="select a company"
                                    required
                                    multiple

                                    error={error.company}
                                /> */}
                <div
                  className={mainStyle.mainButtonDiv}
                  style={{ width: "100%" }}
                >
                  <Button onClick={handleSubmit}>
                    {" "}
                    {loading ? <Loader /> : "Invite"}
                  </Button>
                </div>
              </div>

              <br />
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default AddUserListPage;
